module.exports = __webpack_public_path__ + "static/media/c_hxcf_icon_youjiantou_10_grayss.ac39c8b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/c_hxcf_icon_youjiantou_10_grayss.png
// module id = 1971
// module chunks = 0